/* global Sys, Core, Resources */
Sys.ns("Core");

/**
 * The Keep Alive model.
 *
 * @class Core.KeepAliveModel
 * @extends Core.Model
 */
Core.KeepAliveModel = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.KeepAliveModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @inheritdoc
     */
    setupData: function() {
        var queryData = Resources.readData("queryData"),
            url = queryData.keepAliveURL,
            interval = queryData.keepAliveInterval,
            sessionID = Resources.readData("sessionID");

        if (sessionID && Sys.utils.isUrl(url) && parseInt(interval, 10) >= 5) {
            this.storeData("url", Sys.utils.appendParameterToQuery(url, "sessId=" + sessionID));
            this.storeData("interval", interval * 1000);
        }
    }
};

Core.KeepAliveModel = Sys.extend(Core.Model, Core.KeepAliveModel, "Core.KeepAliveModel");
